import http from '@/utils/http';

export default {
	uploadImage: data => {
		return http({ url: '/api/admin/v1/basic/uploadImage', data,tip:true }).then(r => r);
	},
	removeImage: data => {
		return http({ url: '/api/admin/v1/basic/removeImage', data,tip:true }).then(r => r);
	},
	exportExcel: data => {
		return http({ url: '/api/admin/v1/basic/exportExcel', data, tip: true }).then(r => r);
	},
	uploadImageFile: data => {
		return http({url:'/api/admin/v1/basic/uploadImageFile',data,tip:true,files:true}).then(r => r);
	},
	getArea: () => {
		return http({url:'/api/admin/v1/basic/getArea'}).then(r => r);
	},
	getCityArea: () => {
		return http({url:'/api/admin/v1/basic/getCityArea'}).then(r => r);
	},
	commonExport: data => {
		return http({ url: '/api/admin/v1/basic/commonExport', data}).then(r => r);
	},
	getExportProgress: data => {
		return http({ url: '/api/admin/v1/basic/getExportProgress', data }).then(r => r);
	}
}